import React from 'react';
import { colors } from '../../../colors';

const Tag = ({
  handlePress,
  value,
  isSelected,
}: {
  handlePress: () => void;
  value: string;
  isSelected: boolean;
}) => {
  return (
    <span
      onClick={handlePress}
      style={{
        cursor: isSelected ? 'default' : 'pointer',
        backgroundColor: colors.white,
        paddingLeft: 8,
        paddingRight: 8,
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 'bold',
        opacity: isSelected ? 1 : 0.3,
        width: 'fit-content',
      }}
    >
      {value}
    </span>
  );
};

export default Tag;
